







import { Component, Prop, Vue } from 'vue-property-decorator'
import Country from '@/dto/deliveries/Country'
import { Formatter } from 'vue-kit'

@Component
export default class PlaceSelectSearchHint extends Vue {
  @Prop(Object) country: Country

  get countText(): string {
    const countFormatter = this.country.citiesCount.toLocaleString('ru-RU')

    return `${countFormatter} ${Formatter.num2str(
      this.country.citiesCount,
      'населенный пункт',
      'населенных пункта',
      'населенных пунктов'
    )}`
  }
}
